export default "__VITE_ASSET__73b989c6__"